export default class User {
  constructor(
    username = '',
    email = '',
    age = 0,
    sex = '',
    weight = 0,
    height = 0,
    weightObjective = 0,
    secondaryObjective = [],
    activityLevel = '',
    takenMeals = [],
    takenMealsObjectives = [],
    intolerances = [],
    diet = [],
    meatConsumption = '',
    alcoholConsumption = false,
    ingredientsToAvoid = [],
    ingredientsToInclude = [],
    medicalConditions = [],
    preferedGroceryStore = '',
    cookingSkills = '',
    averageCookingTime = 0, //Do an average, if we choose 30-45min, then averageCookingTime = 37.5
    equipement = {
      oven: false,
      microwave: false,
      foodProcessor: false,
      blender: false,
      airFryer: false
    },
    weeklyNutrionalRecap = false,
    weeklyMealGeneration = false,
  ) {
    this.username = username;
    this.email = email;
    this.age = age;
    this.sex = sex;
    this.weight = weight;
    this.height = height;
    this.weightObjective = weightObjective;
    this.secondaryObjective = secondaryObjective;
    this.activityLevel = activityLevel;
    this.takenMeals = takenMeals;
    this.takenMealsObjectives = takenMealsObjectives;
    this.intolerances = intolerances;
    this.diet = diet;
    this.meatConsumption = meatConsumption;
    this.alcoholConsumption = alcoholConsumption;
    this.ingredientsToAvoid = ingredientsToAvoid;
    this.ingredientsToInclude = ingredientsToInclude;
    this.medicalConditions = medicalConditions;
    this.preferedGroceryStore = preferedGroceryStore;
    this.cookingSkills = cookingSkills;
    this.averageCookingTime = averageCookingTime;
    this.equipement = equipement;
    this.weeklyNutrionalRecap = weeklyNutrionalRecap;
    this.weeklyMealGeneration = weeklyMealGeneration;
  }
}
